import { render, staticRenderFns } from "./distributorStockList.vue?vue&type=template&id=74d4c0b8&scoped=true"
import script from "./distributorStockList.vue?vue&type=script&lang=js"
export * from "./distributorStockList.vue?vue&type=script&lang=js"
import style0 from "./distributorStockList.vue?vue&type=style&index=0&id=74d4c0b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d4c0b8",
  null
  
)

export default component.exports